module.exports = "<div [hidden]=\"!active\"  class=\"pane\">\n    <ng-content></ng-content>\n    <ng-container>\n        <div class=\"tabContent compWidth-100\">         \n            <div>\n                <table2 [(options)]=\"gridOptions\">\n                </table2>\n            </div>\n        </div>\n    </ng-container>\n</div>\n "


//////////////////
// WEBPACK FOOTER
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/continuosNumber/continuosNumber.html
// module id = ../../../../../src/app/components/report/continuosNumber/continuosNumber.html
// module chunks = main